import { render, staticRenderFns } from "./Prizes.vue?vue&type=template&id=8822ae16&scoped=true"
import script from "./Prizes.vue?vue&type=script&lang=js"
export * from "./Prizes.vue?vue&type=script&lang=js"
import style0 from "./Prizes.vue?vue&type=style&index=0&id=8822ae16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8822ae16",
  null
  
)

export default component.exports